
 // src/pages/About.jsx
import React from 'react';
import Card2D from '../components/Card2D';

const Hero = ({ title, subtitle, images, backgroundImage, showButtons = true }) => (
  <div className="relative h-screen z-10 overflow-hidden">
    {/* Background Image */}
    <div 
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage || images[0]})` }}
    >
      <div className="absolute inset-0 bg-black/40"></div>
    </div>

    {/* Content Overlay */}
        <div className="relative z-10 h-full flex items-center text-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="max-w-2xl mx-auto">
              <h1 className="font-libre text-4xl md:text-5xl lg:text-5xl font-medium text-yellow-400 mb-6">
                {title}
              </h1>
              <p className="font-inter text-lg text-yellow-100">
                {subtitle}
              </p>
            </div>
          </div>
        </div>
  </div>
)


const About = () => {

  return (
    <div className="relative min-h-screen overflow-hidden bg-white">

    <Hero 
      title="A Data-Driven Approach to Understanding Evolving Market Needs."
      subtitle="We deliver sharp, data-driven market insights that help clients anticipate trends, identify opportunities, and make strategic decisions with confidence."
      backgroundImage="/newinsight.jpg"
      showButtons={false}
    />

      {/* Page Content */}
        <p className='font-inter relative text-4xl z-10 max-w-4xl mx-auto py-24 px-4 space-y-20 italic text-center text-ofanda-indigo animate-slideRotate'>
          Watch out for this space.
        </p>

      {/* CTA Section */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className=" rounded-2xl p-12 text-center relative overflow-hidden" style={{ backgroundColor: '#0A1F5C' }}>
          {/* Bottom Left Circle */}
          <div className="absolute bottom-0 left-0 w-40 h-40 border-4 border-white rounded-full -translate-x-28 translate-y-10 opacity-30"></div>

          {/* Top Right Circle */}
          <div className="absolute top-0 right-0 w-40 h-40 border-4 border-white rounded-full translate-x-28 -translate-y-10 opacity-30"></div>

          <div className="relative z-10">
            <h2 className="font-inter font-medium text-3xl md:text-4xl font-bold text-white mb-8">
              Let's Build The Future Together
            </h2>
            <div className="flex flex-col sm:flex-row justify-center gap-4 font-inter">
              <a href="/services">
                <button className="px-8 py-3 bg-black text-white font-medium rounded-lg hover:bg-gray-800 transition-colors duration-300">
                  Learn More
                </button>
              </a>
              <a href="/contact">
                <button className="px-8 py-3 bg-yellow-400 text-gray-900 font-medium rounded-lg hover:bg-yellow-500 transition-colors duration-300">
                  Start a Project
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Animations */}

        <style>{`
          @keyframes doodleMove {
            0% { transform: translate(0,0); }
            50% { transform: translate(-20px,-40px); }
            100% { transform: translate(0,0); }
          }

          @keyframes shimmer {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }

          @keyframes slideRotate {
            0% {
              opacity: 0;
              transform: translateX(-100%) rotate(-10deg) scale(0.8);
            }
            50% {
              transform: translateX(10%) rotate(2deg) scale(1.05);
            }
            100% {
              opacity: 1;
              transform: translateX(0) rotate(0deg) scale(1);
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translateY(0px) rotate(0deg);
            }
            25% {
              transform: translateY(-10px) rotate(1deg);
            }
            75% {
              transform: translateY(-5px) rotate(-1deg);
            }
          }

          .animate-doodleMove {
            animation: doodleMove 90s linear infinite;
          }

          .animate-shimmer {
            animation: shimmer 8s linear infinite;
          }

          .animate-slideRotate {
            animation: slideRotate 1.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards,
                      float 4s ease-in-out infinite 1.5s;
          }
        `}</style>
    </div>
  );
};

export default About;
